// =============================================================================
// Limit lokalizacji planu — zdanie dla ekranu Lokalizacje.
//
// Limit egzekwuje BAZA (wyzwalacz `trg_lokalizacje_limit_planu` na `locations`,
// etap 4 planu 56): zapis zakładu ponad `organization_entitlements.locations`
// kończy się wyjątkiem `location_limit_exceeded`, a polskie zdanie z liczbą
// zajętych i limitem jedzie w HINT. Ekran nie liczy limitu po swojemu — druga
// kopia reguły rozjechałaby się z bazą przy pierwszej zmianie pakietu — tylko
// pokazuje zdanie bazy zamiast ogólnego „Nie udało się zapisać lokalizacji”.
// =============================================================================

/** Kod wyjątku bramki limitu lokalizacji (MESSAGE w Postgresie). */
export const KOD_LIMITU_LOKALIZACJI = 'location_limit_exceeded';

const ZDANIE_DOMYSLNE = 'Nie udało się zapisać lokalizacji';
const ZDANIE_LIMITU_BEZ_HINTU =
  'Osiągnięto limit lokalizacji w Twoim pakiecie. Zwiększ pakiet albo usuń inną lokalizację.';

/** Błąd PostgREST/supabase-js — interesują nas tylko te dwa pola. */
interface BladZapisu {
  message?: unknown;
  hint?: unknown;
}

/** Zdanie dla człowieka po nieudanym zapisie zakładu na ekranie Lokalizacje. */
export function komunikatZapisuLokalizacji(blad: unknown): string {
  if (!blad || typeof blad !== 'object') return ZDANIE_DOMYSLNE;
  const { message, hint } = blad as BladZapisu;
  if (typeof message !== 'string' || !message.includes(KOD_LIMITU_LOKALIZACJI)) {
    return ZDANIE_DOMYSLNE;
  }
  return typeof hint === 'string' && hint.trim() !== '' ? hint.trim() : ZDANIE_LIMITU_BEZ_HINTU;
}
